import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import Form from "../../components/StaticPageForm";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { localizedTextDefaultValue } from "../../constants/localizedTextDefaultValue";
import {
  UpdateSubsidiaryPageDto,
  LocalizedText,
} from "../../services/generated/client";
import {
  getSubsidiaryPage,
  upsertSubsidiaryPage,
} from "../../services/subsidiaryPage/subsidiaresPageServices";
import styles from "./styles.module.css";
import { useApi } from "../../services/api";

const SubsidiaryPageText = () => {
  const [subsidiaryPage, setSubsidiaryPage] = useState<UpdateSubsidiaryPageDto>(
    {
      paragraph1: localizedTextDefaultValue,
      paragraph2: localizedTextDefaultValue,
    }
  );
  const [languageEditing, setLanguageEditing] =
    useState<keyof LocalizedText>("ka");
  const { withErrorHandling } = useApi();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSubsidiaryPage = async () => {
      try {
        const response = await getSubsidiaryPage();
        if (response) {
          setSubsidiaryPage(response);
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
    fetchSubsidiaryPage();
  }, []);

  const handleUpdateSubsidiaryPage = async (e: FormEvent) => {
    e.preventDefault();

    const { paragraph1, paragraph2 } = subsidiaryPage;

    const newSubsidiaryPage = await withErrorHandling(async () => {
      return await upsertSubsidiaryPage({
        paragraph1,
        paragraph2,
      });
    });
    if (newSubsidiaryPage) {
      setSubsidiaryPage(newSubsidiaryPage);
    }
  };

  const handleMultiLanguageInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const id = e.target.id as keyof UpdateSubsidiaryPageDto;
    const value = e.target.value;

    setSubsidiaryPage((prev) => ({
      ...prev,
      [id]: {
        ...(prev[id] as LocalizedText),
        [languageEditing]: value,
      },
    }));
  };

  if (isLoading) {
    return <div className={styles.mainContent}>Loading...</div>;
  }

  return (
    <div className={styles.mainContent}>
      <div className={styles.formConteiner}>
        <div className={styles.formWrapper}>
          <LanguageSwitcher
            languageEditing={languageEditing}
            setLanguageEditing={setLanguageEditing}
            inForm={true}
          />
          <Form
            title={"Edit Subsidiary Page"}
            submitLabel={"Update"}
            onSubmit={handleUpdateSubsidiaryPage}
            isView={false}
            languageEditing={languageEditing}
            fields={[
              {
                id: "paragraph1",
                label: `Paragraph 1 ${languageEditing.toUpperCase()}`,
                type: "textarea",
                value:
                  subsidiaryPage?.paragraph1?.[
                    languageEditing as keyof LocalizedText
                  ] || "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
              {
                id: "paragraph2",
                label: `Paragraph 2 ${languageEditing.toUpperCase()}`,
                type: "textarea",
                value:
                  subsidiaryPage?.paragraph2?.[
                    languageEditing as keyof LocalizedText
                  ] || "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default SubsidiaryPageText;
